export default function formatShortAddress(address) {
  if (!address) return ''
  return (`${address.neighborhood}, ${address.city} - ${address.state}`)
}


